/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionInfo = {
  properties: {
    id: {
      type: 'string',
      isRequired: true,
    },
    displayName: {
      type: 'string',
      isRequired: true,
    },
    status: {
      type: 'OnboardingProfessionStatus',
      isRequired: true,
    },
    boards: {
      type: 'array',
      contains: {
        type: 'string',
      },
      isRequired: true,
    },
  },
} as const;
